import { Controller } from "stimulus"

// Closes the sidebar on mobile viewports (under 1024px) when learning actions are clicked
// This ensures the user can see the left column content after clicking learning buttons
export default class extends Controller {
  close() {
    // Only close sidebar on viewports under 1024px
    if (window.innerWidth >= 1024) return

    const sidebar = document.getElementById("AiSidebar")
    const expandButton = document.getElementById("sidebarExpandButton")

    if (sidebar) {
      sidebar.classList.remove("d-flex", "open", "expanded", "d-lg-flex", "sidebar-default-visible")
      sidebar.classList.add("d-none", "closed")
    }

    if (expandButton) {
      expandButton.classList.remove("d-none")
    }
  }
}
